export enum UPDATE_PASSWORD_OTP_TYPE {
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  UPDATE_PASSWORD = 'UPDATE_PASSWORD'
}
